import { Input } from "../common";

const CreditCardForm = ({ cardData, setCardData, errors = {} }) => {
  const formatCardNumber = (value) => {
    // Remove all non-digits
    const v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
    // Add spaces every 4 digits
    const matches = v.match(/\d{4,16}/g);
    const match = (matches && matches[0]) || "";
    const parts = [];
    for (let i = 0, len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i + 4));
    }
    if (parts.length) {
      return parts.join(" ");
    } else {
      return v;
    }
  };

  const formatExpiry = (value) => {
    const v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
    if (v.length >= 2) {
      return v.substring(0, 2) + "/" + v.substring(2, 4);
    }
    return v;
  };

  const formatCVV = (value) => {
    return value
      .replace(/\s+/g, "")
      .replace(/[^0-9]/gi, "")
      .substring(0, 4);
  };

  const handleCardNumberChange = (value) => {
    const formatted = formatCardNumber(value);
    setCardData({ ...cardData, cardNumber: formatted });
  };

  const handleExpiryChange = (value) => {
    const formatted = formatExpiry(value);
    setCardData({ ...cardData, expiry: formatted });
  };

  const handleCVVChange = (value) => {
    const formatted = formatCVV(value);
    setCardData({ ...cardData, cvv: formatted });
  };

  const handleCardholderNameChange = (value) => {
    setCardData({ ...cardData, cardholderName: value });
  };

  // Extract month and year from expiry
  const expiryParts = cardData.expiry?.split("/") || [];
  const expiryMonth = expiryParts[0] || "";
  const expiryYear = expiryParts[1] || "";

  return (
    <div className="flex flex-col gap-4">
      <div>
        <Input
          label="Card Number"
          placeholder="1234 5678 9012 3456"
          icon="mdi:credit-card-outline"
          value={cardData.cardNumber || ""}
          onChange={handleCardNumberChange}
          type="text"
          maxLength={19}
        />
        {errors.cardNumber && (
          <p className="text-red-500 text-xs mt-1">{errors.cardNumber}</p>
        )}
      </div>

      <div>
        <Input
          label="Cardholder Name"
          placeholder="John Doe"
          icon="mdi:account-outline"
          value={cardData.cardholderName || ""}
          onChange={handleCardholderNameChange}
          type="text"
        />
        {errors.cardholderName && (
          <p className="text-red-500 text-xs mt-1">{errors.cardholderName}</p>
        )}
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <Input
            label="Expiry Date"
            placeholder="MM/YY"
            icon="mdi:calendar-outline"
            value={cardData.expiry || ""}
            onChange={handleExpiryChange}
            type="text"
            maxLength={5}
          />
          {errors.expiry && (
            <p className="text-red-500 text-xs mt-1">{errors.expiry}</p>
          )}
        </div>

        <div>
          <Input
            label="CVV"
            placeholder="123"
            icon="mdi:lock-outline"
            value={cardData.cvv || ""}
            onChange={handleCVVChange}
            type="text"
            maxLength={4}
          />
          {errors.cvv && (
            <p className="text-red-500 text-xs mt-1">{errors.cvv}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreditCardForm;
